<div class="outerwrap" fxLayout="column" fxLayoutAlign="start stretch">
    <h1 mat-dialog-title class="title-bar">
        <span class="dialog-title">{{title}}</span>
        <mat-icon class="icon angular" *ngIf="showIcon" [color]="iconcolor">{{iconname}}</mat-icon>
    </h1>
    <div class="centerwrap scroll content" fxFlex.gt-sm="auto">
        <div class="dialog-message" [innerHTML]="message | safeHTML"></div>
    </div>
    <div
        class="button-bar"
        fxLayout="row"
        fxLayoutAlign="end center"
        fxLayoutGap="15px"
        fxLayout.lt-md="column"
        fxLayoutAlign.lt-md="center center"
        fxLayoutGap.lt-md="10px"
    >
        <button mat-raised-button color="warn" class="cancelbtn" (click)="CancelHandler()">
            <span>{{canceltext}}</span>
        </button>
        <button mat-raised-button color="primary" class="okbtn" (click)="OKHandler()">
            <span>{{oktext}}</span>
        </button>        
    </div>
</div>
